<template>
    <div>
        <div :class="$style.wraper">
            <img v-if="tripImg" :class="$style.trip_img" :src="tripImg" alt="行程图" />

            <div :class="$style.trip_table_wrap">
                <el-scrollbar :view-style="{
                    maxHeight: maxHeight ? maxHeight : 'none'
                }">
                    <el-table :class="$style.trip_table" :data="limitTours" header-row-class-name="thead" :row-class-name="rowClassFunc">
                        <el-table-column label="天" prop="day" width="72" #default="{row}">
                            <span class="pl-1">{{ row.day > 0 ? row.day : '-' }}</span>
                        </el-table-column>
                        <el-table-column label="停靠港口" prop="itinerary"  #default="{row}">
                            <div class="flex items-center"><img :src="row.flag" v-if="row.flag" class="w-6 inline-block mr-4"/>{{ row.itinerary || '-' }}</div>
                        </el-table-column>
                        <el-table-column label="抵港时间" prop="arrive_time" width="140"  #default="{row}">
                            {{ row.arrive_time || '-' }}
                        </el-table-column>
                        <el-table-column label="离港时间" prop="depart_time" width="140" #default="{row}">
                            {{ row.depart_time || '-' }}
                        </el-table-column>
                        <el-table-column type="expand">
                            <template slot-scope="scope">
                                <product-detail-route-ports :content="scope.row.shore_desc" :portsName="scope.row.itinerary" :swipers="scope.row.shore_images"/>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-scrollbar>
            </div>
        </div>
        <div v-if="expandable && !expand && tours.length > 8" class="text-right mt-4">
            <button type="button" class="text-dark border border-current rounded-full py-1 px-3"
                @click="expand = true"><span>查看更多</span><i class="ml-1 ficon ficon-arrow-bottom"></i></button>
        </div>
    </div>
</template>
<script>
import { defineComponent } from "@nuxtjs/composition-api";
import ProductDetailRoutePorts from "@/components/automation/product-detail-route-ports"


export default defineComponent({
    props: {
        tripImg: String,
        tours: {
            type: Array,
            default: () => []
        },
        expandable: {
            type: Boolean,
            default: true
        },
        maxHeight: String
    },
    data() {
        return {
            expand: false
        }
    },
    components:{
        ProductDetailRoutePorts
    },
    computed: {
        limitTours() {
            if (!this.expandable || this.expand || this.tours.length <= 8) {
                return this.tours;
            }
            return this.tours.slice(0, 8)
        }
    },
    methods:{
        rowClassFunc({ row }) {
            if(row.shore_images?.length || row.shore_desc) {
                return 'my_row'
            }
            return 'no_expand'
        }
    }
})
</script>
<style lang="scss" module>
.wraper {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: start;
  -ms-flex-align: start;
  -webkit-align-items: flex-start;
  align-items: flex-start;
}
.trip_img {
  margin-right: 1rem;
  width: 22.5rem;
}
.trip_table {
  font-size: 1rem;
  line-height: 1.5rem;
  width: 100%;
}
.trip_table_wrap {
  -webkit-box-flex: 1;
  -ms-flex: 1 1 0%;
  -webkit-flex: 1 1 0%;
  flex: 1 1 0%;
}
</style>
<style lang="scss" scoped>

    ::v-deep{
        .thead{
            background-color: #f5f5f5;
            .cell{
                font-weight: 500 !important;
                color: #606370;
                padding-left: 16px;
            }
            th:first-child .cell{
                padding-left: 12px !important;
            }
        }
        tr.expanded{
            background-color: rgba(0,94,220,0.06);
        }
        .el-table__expand-icon{
            font-size: 18px;
        }
        
        .my_row{
            .el-table__expand-icon{
                .el-icon{
                    margin-top: -9px;
                    margin-left: -9px;
                }
            }
        }
        .no_expand{
            .el-table__expand-icon{
                display: none;
            }
        }
    }

</style>
